import React from 'react'


export default ({children}) => (
    <h2 className="font-header  font-bold text-cobalt  text-4xl  font-normal  mb-4">{children}</h2>
)
